import {styled} from '@ngw6/us-components';

export const DealerDetailWrapper: any = styled.div`
  display: flex;
`;
export const DealerDetailIcon: any = styled.div`
  align-self: baseline;
  margin-right: 11px;
`;

export const DealerDetailText: any = styled.div``;

export const StyledIcon: any = styled.div`
  color: ${(props: any) => props.theme.border.color.primary};
  display: flex;
  width: 100%;
  height: 91%;
  justify-content: flex-start;
  align-items: center;
`;
